module.exports = __webpack_public_path__ + "static/zebra-logo-512-7dd86a696d40533d2fca4e596882fdca.png";